import React from 'react'

// query
import { useQuery } from '@apollo/client'
import { GET_JOB_BY_ID_NAME } from '../../../../graphql/job/job.queries'

// components
import { Typography } from '@mui/material'

export default function JobName({ id }) {
    let name = ""
    const { loading, error, data } = useQuery(GET_JOB_BY_ID_NAME, {
        variables: { id: Number.parseInt(id) }
    })

    if(data && data.job) {
        name = data.job.name
    }

    return (<Typography variant="h2">{name}</Typography>)
}